module.exports = __webpack_public_path__ + "static/img/码上问卷@4x.230e39bd.png";